// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"159":"a0d7c985","168":"95fec6e6","339":"0bad3a50","774":"904df173","895":"e8fc8434"}[chunkId] + ".css";
};